import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';


export default class SizeManagement {

  #rmp;
  #throttledResizeFn = null;
  #initialAspectRatio = 16 / 9;
  #initialWidth = -1;
  #initialHeight = -1;
  #parentElementWidth = -1;
  #throttledResizeTimeoutFn = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get initialWidth() {
    return this.#initialWidth;
  }

  set initialWidth(width) {
    this.#initialWidth = width;
  }

  get initialHeight() {
    return this.#initialHeight;
  }

  set initialHeight(height) {
    this.#initialHeight = height;
  }

  #throttledResize(e) {
    if (e) {
      if (e.type === 'change') {
        this.resizePlayer();
      } else if (e.type === 'resize') {
        if (this.#throttledResizeTimeoutFn === null) {
          this.#throttledResizeTimeoutFn = window.setTimeout(() => {
            this.resizePlayer();
            this.#throttledResizeTimeoutFn = null;
          }, 67);
        }
      }
    }
  }

  #resizeAds() {
    Logger.print('size', 'resize ads');
    let fullscreenWidth = -1;
    let fullscreenHeight = -1;
    if (this.#rmp.isInFullscreen) {
      if (this.#rmp.hasNativeFullscreenSupport) {
        fullscreenWidth = Env.screenDimension.width;
        fullscreenHeight = Env.screenDimension.height;
      } else if (this.#rmp.fullscreenFullWindowMode) {
        fullscreenWidth = Env.viewportSize.width;
        fullscreenHeight = Env.viewportSize.height;
      }
    }
    const playerSize = this.#rmp.getPlayerSize();
    if (this.#rmp.rmpVast) {
      if (this.#rmp.isInFullscreen) {
        if (fullscreenWidth > 0 && fullscreenHeight > 0) {
          if (this.#rmp.hasNativeFullscreenSupport) {
            try {
              this.#rmp.rmpVast.resizeAd(fullscreenWidth, fullscreenHeight, 'fullscreen');
            } catch (warning) {
              console.warn(warning);
            }
          } else if (this.#rmp.fullscreenFullWindowMode) {
            try {
              this.#rmp.rmpVast.resizeAd(fullscreenWidth, fullscreenHeight, 'normal');
            } catch (warning) {
              console.warn(warning);
            }
          }
        }
      } else {
        try {
          this.#rmp.rmpVast.resizeAd(playerSize.width, playerSize.height, 'normal');
        } catch (warning) {
          console.warn(warning);
        }
      }
    } else if (this.#rmp.imaAdsManager) {
      if (!this.#rmp.isInFullscreen) {
        this.#rmp.imaAdsManager.resize(playerSize.width, playerSize.height);
      } else {
        if (fullscreenWidth > 0 && fullscreenHeight > 0) {
          Logger.print('size', `fullscreenWidth: ${fullscreenWidth} - fullscreenHeight: ${fullscreenHeight}`);
          this.#rmp.imaAdsManager.resize(fullscreenWidth, fullscreenHeight);
        }
      }
    }
  }

  #auxiliaryResize() {
    Logger.print('size', 'auxiliaryResize');
    const playerSize = this.#rmp.getPlayerSize();
    const widthPlayer = playerSize.width;
    const heightPlayer = playerSize.height;
    if (widthPlayer > 0) {
      let className = 'rmp-xl';
      this.#rmp.dom.container.classList.remove('rmp-xl', 'rmp-lg', 'rmp-md', 'rmp-sm', 'rmp-xs');
      if (widthPlayer < 320) {
        className = 'rmp-xs';
      } else if (widthPlayer < 480) {
        className = 'rmp-sm';
      } else if (widthPlayer < 640) {
        className = 'rmp-md';
      } else if (widthPlayer < 1024) {
        className = 'rmp-lg';
      }
      Logger.print('size', `player container new sizing class is: ${className}`);
      this.#rmp.dom.container.classList.add(className);
    }
    if (this.#rmp.adOnStage) {
      this.#resizeAds();
    }
    if (this.#rmp.rmpThreeSixty) {
      this.#rmp.rmpThreeSixty.resize360();
    }
    Logger.print('size', `new widthPlayer ${widthPlayer} - previous widthPlayer ${this.#rmp.previousPlayerSize.width}`);
    if (widthPlayer !== this.#rmp.previousPlayerSize.width || heightPlayer !== this.#rmp.previousPlayerSize.height) {
      this.#rmp.dispatch('resize');
    }
  }

  destroy() {
    window.clearTimeout(this.#throttledResizeTimeoutFn);
    window.removeEventListener('resize', this.#throttledResizeFn);
    if (Env.hasScreenOrientationAPI) {
      window.screen.orientation.removeEventListener('change', this.#throttledResizeFn);
    }
  }

  resizePlayer(firstResize) {
    const previousPlayerSize = this.#rmp.getPlayerSize();
    this.#rmp.previousPlayerSize = {
      width: previousPlayerSize.width,
      height: previousPlayerSize.height
    };
    Logger.print('size', `resize requested - previousPlayerSize.width is ${previousPlayerSize.width}`);

    // sometimes resizePlayer might be called before container is defined (invalid input id with init)
    if (!this.#rmp.dom.container) {
      return;
    }
    if (this.#rmp.isInFullscreen) {
      if (this.#rmp.fullscreenFullWindowMode) {
        if (Env.viewportSize.width > 0 && Env.viewportSize.height > 0) {
          this.#rmp.width = Env.viewportSize.width;
          this.#rmp.height = Env.viewportSize.height;
          this.#rmp.dom.container.style.width = this.#rmp.width + 'px';
          this.#rmp.dom.container.style.height = this.#rmp.height + 'px';
        }
      }
      this.#auxiliaryResize();
      return;
    }
    let parent = this.#rmp.dom.containerParent;
    if (this.#rmp.dom.floatingAnchorElement && this.#rmp.floating) {
      parent = this.#rmp.dom.floatingAnchorElement.parentNode;
    }
    if (this.#rmp.iframeMode) {
      if (firstResize) {
        this.#rmp.dom.container.style.width = '100%';
        this.#rmp.dom.container.style.height = '100%';
        if (this.#rmp.audioOnly) {
          this.#rmp.dom.container.style.height = '48px';
        }
      }
      this.#rmp.width = FW.getPrecisionWidthNoPaddingNoBorder(parent);
      this.#rmp.height = FW.getPrecisionHeightNoPaddingNoBorder(parent);
    } else {
      let widthPlayer = 0;
      let heightPlayer = 0;
      const parentWidth = FW.getPrecisionWidthNoPaddingNoBorder(parent);
      Logger.print('size', 'player container parent width is ' + parentWidth);
      if (parentWidth >= this.#initialWidth) {
        widthPlayer = this.#initialWidth;
        heightPlayer = this.#initialHeight;
      } else {
        widthPlayer = parentWidth;
        heightPlayer = parentWidth / this.#initialAspectRatio;
      }
      Logger.print('size', 'updated computed sizes are: width ' + widthPlayer + ' - height ' + heightPlayer);
      if (widthPlayer === 0 || heightPlayer === 0) {
        Logger.print('size', 'widthPlayer or heightPlayer is equal to 0 - using player default values');
        if (this.#rmp.autoHeightMode) {
          this.#rmp.autoHeightMode = false;
          this.#initialWidth = 640;
          this.#initialHeight = 360;
          this.#initialAspectRatio = 16 / 9;
        }
        this.#rmp.width = this.#initialWidth;
        this.#rmp.height = this.#initialHeight;
        widthPlayer = this.#initialWidth + 'px';
        heightPlayer = this.#initialHeight + 'px';
      } else {
        this.#rmp.width = widthPlayer;
        this.#rmp.height = heightPlayer;
        if (this.#rmp.autoHeightMode) {
          widthPlayer = '100%';
          heightPlayer = heightPlayer + 'px';
        } else {
          if (this.#rmp.audioOnly) {
            heightPlayer = 48;
          }
          widthPlayer = widthPlayer + 'px';
          heightPlayer = heightPlayer + 'px';
        }
      }
      this.#rmp.dom.container.style.width = widthPlayer;
      this.#rmp.dom.container.style.height = heightPlayer;
      if (this.#rmp.dom.floatingAnchorElement && this.#rmp.floating) {
        this.#rmp.dom.floatingAnchorElement.style.width = widthPlayer;
        this.#rmp.dom.floatingAnchorElement.style.height = heightPlayer;
      }
    }
    this.#auxiliaryResize();
  }

  initialSizing() {
    Logger.print('size', 'initial player sizing begins');
    if (this.#rmp.iframeMode && this.#rmp.autoHeightMode) {
      this.#rmp.autoHeightMode = false;
    }
    if (this.#rmp.iframeMode) {
      this.#rmp.width = FW.getPrecisionWidthNoPaddingNoBorder(this.#rmp.dom.containerParent);
      this.#rmp.height = FW.getPrecisionHeightNoPaddingNoBorder(this.#rmp.dom.containerParent);
    } else if (this.#rmp.autoHeightMode) {
      this.#rmp.width = FW.getPrecisionWidthNoPaddingNoBorder(this.#rmp.dom.containerParent);
      this.#rmp.height = this.#rmp.width / this.#rmp.autoHeightModeRatio;
    } else {
      this.#rmp.autoHeightMode = false;
      this.#rmp.iframeMode = false;
    }
    this.#initialWidth = this.#rmp.width;
    this.#initialHeight = this.#rmp.height;
    this.#initialAspectRatio = this.#initialWidth / this.#initialHeight;
    if (this.#rmp.autoHeightMode) {
      this.#initialWidth = 999999;
      this.#initialAspectRatio = this.#rmp.autoHeightModeRatio;
    }
    this.resizePlayer(true);

    // watch for parent container resize
    if (typeof ResizeObserver !== 'undefined' && !this.#rmp.iframeMode) {
      const resizeObserver = new ResizeObserver(entries => {
        requestAnimationFrame(() => {
          for (const entry of entries) {
            const width = entry.contentRect.width;
            Logger.print('size', 'ResizeObserver detected changes in player parent size: width is ' + width);
            if (width <= 0) {
              return;
            }
            if (this.#parentElementWidth <= 0) {
              this.#parentElementWidth = width;
              this.resizePlayer();
              return;
            }
            if (width !== this.#parentElementWidth) {
              this.#parentElementWidth = width;
              this.resizePlayer();
            }
          }
        });
      });
      resizeObserver.observe(this.#rmp.dom.containerParent);

      window.addEventListener('error', (error) => {
        Logger.print('info', 'error on window object follows', error);
      });
    } else {
      this.#throttledResizeFn = this.#throttledResize.bind(this);
      window.addEventListener('resize', this.#throttledResizeFn);
      if (Env.hasScreenOrientationAPI) {
        window.screen.orientation.addEventListener('change', this.#throttledResizeFn);
      }
    }
  }

}
